// extracted by mini-css-extract-plugin
export default {"message":"PunchupErrorModal_message__EujJr"};